import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import Access from "../../../CustomComponents/Access/Access";
import { useNavigate } from "react-router-dom";
import { FilterOTSListings } from "../../../../redux/ots/action";
import { useDispatch, useSelector } from "react-redux";
import { navigateToNextTab } from "../../../Common/FewCommonMethods";
import GlobalSearch from "../../../Layouts/PrivateRouteLayouts/GlobalSearch";
import { Check } from "lucide-react";
import Check401Api from "./Check401Api";

export default function Homepage() {
  const path = "Assets/scss/homepage.module.scss";
  const [onhover, setOnhover] = useState(false);
  const [modal, setModal] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  useEffect(() => {
    const handleFocus = () => {
      LoadCSSforfirstTime(path);
    };

    window.addEventListener("focus", handleFocus);

    // cleanup
    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [path]);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();

  const data = {
    method: "GET",
    index: 0,
    size: 4,
  }

  // useEffect(() => {
  //   dispatch(FilterOTSListings(data));
  //   window.scrollTo({
  //     top: 600,
  //     behavior: "smooth",
  //   });
  // }, []);
  const getpostlist = useSelector(
    ({ ots: { getfilterdots } }) => getfilterdots
  );

  return (
    <div className="homepage">
      <Check401Api />

      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${lan}/submitprojectproposal`}
          state={'state'}
          checkpermission={'bid_project'}
        />
      ) : (
        ""
      )}
      <div className="homepage-first col-lg-5 col-md-8 mx-auto">
        <h2 className="font-42">
          Connect With Top Experts or Find Exciting Post & Browse Projects (PBP)
        </h2>
        {/* <div className="search-bar">
          <div className="search-btn">
            <input
              type="search"
              placeholder="Search Here "
              className="form-control"
            />
            <button className="btn" >
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/homepage/search-btn.svg`}
                alt=""
              />
            </button>
          </div>
          <div
            className={onhover ? "home-dropdown active" : "home-dropdown"}
            onClick={() => setOnhover(true)}
            onMouseEnter={() => setOnhover(true)}
            onMouseLeave={() => setOnhover(false)}
          >
            <a className="nav-item">
              Hire experts
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/homepage/orange-icon.svg`}
                alt=""
              />
            </a>
            <div className="nav-drop">
              <a onClick={() => navigate(`/${lan}/account/hireexpertsmainpage`)} >Find Expert / Company</a>
              <a onClick={() => navigate(`/${lan}/searchdownloadcv`)} >Hire part time</a>
              <a onClick={() => navigate(`/${lan}/searchdownloadcv`)} >Hire Full time</a>
            </div>
          </div>
        </div> */}
        <div className="global-search-home hide-button-home" >
          <GlobalSearch />
        </div>
      </div>
      <div className="homepage-second">
        <div className="upgarde-img">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/homepage/home-banner.png`}
            className="banner w-100"
            alt=""
          />
          <div className="banner-content">
            <h2 className="font-42">
              Upgrade membership <span>& start creating one time</span> services
              (OTS)
            </h2>
            <p>
              Transform your skills into on-demand one-time services. Upgrade today and start monetizing your expertise.
            </p>
            <button className="btn" onClick={() => navigate(`/${lan}/account/upgrademembership`)}>
              View Plans
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
      <div className="col-lg-10 col-md-12 mx-auto homepage-third">
        <div className="row homepage-row">
          <div className="col-md-4 col-6 looking-work">
            <div className="work-job">
              <h6>Looking for work?</h6>
              <h2>Find work</h2>
              <p>
                Browse projects and opportunities that match your skills.
                Connect with clients and start earning today.
              </p>
              <button className="btn" onClick={() => navigate(`/${lan}/searchall`)}>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </button>
            </div>
          </div>
          <div className="col-md-4 col-6 looking-work">
            <div className="work-job">
              <h6>Let’s get things done</h6>
              <h2>Create a post</h2>
              <p>
                Create and publish posts to showcase your needs.
                Get responses and build meaningful connections
              </p>
              <button className="btn" onClick={() => navigate(`/${lan}/createpost`)}>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </button>
            </div>
          </div>
          <div className="col-md-4 col-6 looking-work">
            <div className="work-job">
              <h6>Kickstart your business</h6>
              <h2>Explore one time service (OTS)</h2>
              <p>
                Browse a variety of ready-to-use one-time services.
                Find quick solutions tailored to your needs
              </p>
              <button className="btn" onClick={() => navigate(`/${lan}/searchpackaged`)}>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>
        <div className="skill-sec">
          <h2 className="font-42">
            More than 10k skilled experts in 100+ categories
          </h2>
          <div className="row skill-rows">
            <div className="col-lg-5 col-md-4 col-6">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/homepage/man.png`}
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-lg-6 col-md-8">
              <p>
                Connect with skilled experts from diverse fields.
                Explore multiple categories to find the right match.
              </p>
              <ul>
                <li>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                    alt=""
                  />
                  Robust Search and Recommendation System
                </li>
                <li>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                    alt=""
                  />
                  Onboarding and Skill Verification
                </li>
                <li>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/star.svg`}
                    alt=""
                  />
                  Multi-language and Multi-currency Support
                </li>
              </ul>
              <div className="btn-sec">
                <button className="btn" onClick={() => navigate(`/${lan}/registration`, { state: { type: 1 } })}>
                  Register
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
                <button className="btn" onClick={() => navigate(`/${lan}/createpost`, { state: { theType: 1 } })}>
                  Create a post
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-11 col-md-12 how-it-works-sec mx-auto">
        <div className="homepage-four">
          <div className="how-it">
            <h2 className="font-42">How it works?</h2>
            <ul className="nav nav-tabs tab-section">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#expert">
                  For Experts
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link " data-toggle="tab" href="#user">
                  For Companies
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            <div className="tab-pane active" id="expert">
              <div className="row">
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>1</span>
                    </h3>
                    <div>
                      <h4>Register with us</h4>
                      <p>
                        Create your free expert account and set up your profile
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>2</span>
                    </h3>
                    <div>
                      <h4>Search for job</h4>
                      <p>
                        Find opportunities that match your skills and interests.
                        Apply easily and start your career journey today
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>3</span>
                    </h3>
                    <div>
                      <h4>Send offer</h4>
                      <p>
                        Secure projects that match your expertise.
                        Work with clients and grow your career.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>4</span>
                    </h3>
                    <div>
                      <h4>Get Hired</h4>
                      <p>
                        Trusted platform connecting users with skilled experts.
                        Quality, reliability, and support you can count on.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane " id="user">
              <div className="row">
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>1</span>
                    </h3>
                    <div>
                      <h4>Register with us</h4>
                      <p>
                        Create your free expert account and set up your profile
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>2</span>
                    </h3>
                    <div>
                      <h4>Search for job</h4>
                      <p>
                        Find opportunities that match your skills and interests.
                        Apply easily and start your career journey today
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>3</span>
                    </h3>
                    <div>
                      <h4>Send offer</h4>
                      <p>
                        Secure projects that match your expertise.
                        Work with clients and grow your career.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 register-sec">
                  <div className="reg-cont">
                    <h3>
                      <span>4</span>
                    </h3>
                    <div>
                      <h4>Get Hired</h4>
                      <p>
                        Trusted platform connecting users with skilled experts.
                        Quality, reliability, and support you can count on.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-10 mx-auto why-choose">
        <h2 className="font-42">Why choose us</h2>
        <p>
          Find skilled experts from every field in one place.
        </p>
        <div className="row choose-row">
          <div className="col-md-4 icon-sec col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/icon-1.svg`}
              alt=""
            />
            <h6>Diverse talent pool</h6>
            <p>
              Your payments are always protected with us.
            </p>
          </div>
          <div className="col-md-4 icon-sec col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/icon-2.svg`}
              alt=""
            />
            <h6>Secure Payments</h6>
            <p>
              Work smarter with a smooth and organized process.
            </p>
          </div>
          <div className="col-md-4 icon-sec col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/icon-3.svg`}
              alt=""
            />
            <h6>Efficient Workflow</h6>
            <p>
              Simple, intuitive, and easy to navigate.
            </p>
          </div>
          <div className="col-md-4 icon-sec col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/icon-4.svg`}
              alt=""
            />
            <h6>User-Friendly Interface</h6>
            <p>
              Clear and open communication at every step.
            </p>
          </div>
          <div className="col-md-4 icon-sec col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/icon-5.svg`}
              alt=""
            />
            <h6>Transparent Communicationl</h6>
            <p>
              Ensuring top-quality results you can trust.
            </p>
          </div>
          <div className="col-md-4 icon-sec col-6">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/homepage/icon-6.svg`}
              alt=""
            />
            <h6>Quality Assurance</h6>
            <p>
              Connect with professionals ready to deliver results.
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid user-sec">
        <div className="col-lg-10 mx-auto">
          <div className="row">
            <div className="col-md-6">
              <h6>For Users</h6>
              <h2 className="font-42">
                Advance solution and professional Experts for business
              </h2>
              <div className="expert-sec">
                <div className="hire">
                  <div>
                    <h4>Hire Experts</h4>
                    <p>
                      Easily create posts and connect with experts or clients.
                    </p>
                  </div>
                  <button className="btn" onClick={() => navigate(`/${lan}/hireexpertsmainpage`)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                      alt=""
                    />
                  </button>
                </div>
                <div className="hire">
                  <div>
                    <h4>Create a post</h4>
                    <p>
                      Get expert help through simple one-time offerings.
                    </p>
                  </div>
                  <button className="btn" onClick={() => navigate(`/${lan}/createpost`)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                      alt=""
                    />
                  </button>
                </div>
                <div className="hire">
                  <div>
                    <h4>Build and launch unique OTS tailored to client needs.</h4>
                    <p>
                      Get expert help through simple one-time offerings.
                    </p>
                  </div>
                  <button className="btn" onClick={() => navigate(`/${lan}/searchpackaged`)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                      alt="" />
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-8 mx-auto" >
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/homepage/expert.png`}
                className="w-100"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className="col-lg-10 mx-auto expert-1">
        <h2 className="font-42">Top Categories on Urxprt</h2>
        <div className="row it-row">
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>Development & IT</h5>
              <p>1852 Skills</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>AI Services</h5>
              <p>1852 Skills</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>Design & Creative</h5>
              <p>1852 Skills</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>Sales & marketing</h5>
              <p>1852 Skills</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>
                Writing & <span>Translation</span>
              </h5>
              <p>1852 Skills</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>Admin & customer Support</h5>
              <p>1852 Skills</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>
                Finance & <span>Accounting</span>
              </h5>
              <p>1852 Skills</p>
            </div>
          </div>
          <div className="col-md-3 col-6">
            <div className="it-dev">
              <h5>Engineering & Architecture</h5>
              <p>1852 Skills</p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container-fluid expert-section">
        <div className="col-lg-10 mx-auto">
          <div className="row">
            <div className="col-md-6">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/homepage/user.png`}
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-md-6">
              <h6>For Experts</h6>
              <h2 className="font-42">
                Start your freelancer career with urxprt. Get hired in few
                clicks
              </h2>
              <div className="expert-sec">
                <div className="hire">
                  <div>
                    <h4>Find work</h4>
                    <p>
                      Find freelance and project-based work with ease.
                    </p>
                  </div>
                  <button className="btn" onClick={() => navigate(`/${lan}/searchall`)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                      alt=""
                    />
                  </button>
                </div>
                <div className="hire">
                  <div>
                    <h4>Create one time service (OTS)</h4>
                    <p>
                      Build and launch unique OTS tailored to client needs.
                    </p>
                  </div>
                  <button className="btn" onClick={() => navigate(`/${lan}/dashboard/myotsproducts`)}>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        Array.isArray(getpostlist?.response) &&
        <div className="col-lg-10 mx-auto bxp-section">
          <div className="bxp-head">
            <h3 className="font-42">Browse one time services (OTS)</h3>
            <button className="btn" onClick={() => navigate(`/${lan}/searchpackaged`)}>
              View all
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </button>
          </div>
          <div className="row bxp-mobile-row">
            {getpostlist?.response && getpostlist?.response?.map((item) => (
              <div className="col-md-3 bxp-img col-6"
                onClick={() => navigateToNextTab(`packageddetails/${item?.id}`)}>
                <img
                  src={Array.isArray(item?.files) && item?.files[0]?.file ? item?.files[0]?.file : item?.cover ? item?.cover : `${CloudStorage.cloudurl}/Assets/Images/homepage/bxp-1.png`}
                  className="w-100"
                  alt=""
                />
                <p>{item?.title}</p>
                <h6>${item?.price}</h6>
              </div>
            )

            )
            }
          </div>
        </div>
      }
    </div>
  );
}

// export default Homepage;
